import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTriumphPayStatuses extends Layout {
    sourceInterfaceCodes: DataSource;
    tableTriumphPayStatuses: Table;
}
